var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-flex",
    { staticStyle: { padding: "0" }, attrs: { xs12: "" } },
    [
      _c(
        "v-data-table",
        {
          attrs: { items: _vm.items, "hide-default-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("thead", { staticClass: "v-data-table-header" }, [
                    _c(
                      "tr",
                      _vm._l(_vm.headers, function (header, index) {
                        return _c(
                          "th",
                          { key: "head_" + index, staticClass: "text-center" },
                          [
                            header.barcode
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _vm.canPrintEtichette
                                                    ? _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.openBarcodeDialog(
                                                                  header
                                                                )
                                                              },
                                                            },
                                                          },
                                                          on
                                                        ),
                                                        [_vm._v("mdi-barcode")]
                                                      )
                                                    : _c(
                                                        "v-icon",
                                                        _vm._g({}, on),
                                                        [_vm._v("mdi-barcode")]
                                                      ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(header.barcode)),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" " + _vm._s(header.value) + " "),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _c(
                    "v-dialog",
                    {
                      attrs: { width: "500" },
                      model: {
                        value: _vm.dialog,
                        callback: function ($$v) {
                          _vm.dialog = $$v
                        },
                        expression: "dialog",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass:
                                "headline d-flex justify-space-between",
                            },
                            [
                              _vm._v(_vm._s(_vm.selectedEtichetta) + " "),
                              _c(
                                "v-icon",
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.dialog = false
                                    },
                                  },
                                },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-card-text",
                            [
                              _vm.isStampaEtichettaLoading
                                ? _c(
                                    "div",
                                    { staticClass: "d-flex justify-center" },
                                    [
                                      _c("v-progress-circular", {
                                        attrs: {
                                          size: 50,
                                          color: "primary",
                                          indeterminate: "",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "justify-space-around flex-column align-center",
                                      staticStyle: { gap: "15px" },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: { width: "252px" },
                                          attrs: {
                                            color: "primary",
                                            size: "x-large",
                                            disabled:
                                              !_vm.canPrintEtichette ||
                                              !_vm.stampaEtichetteRfidDisponibile,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.stampaEtichettaPerLavorazioneETaglia(
                                                "PRINT_RFID"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Stampa Etichetta RFID")]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticStyle: { width: "252px" },
                                          attrs: {
                                            color: "primary",
                                            size: "x-large",
                                            disabled:
                                              !_vm.canPrintEtichette ||
                                              !_vm.stampaEtichetteNoRfidDisponibile,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.stampaEtichettaPerLavorazioneETaglia(
                                                "PRINT_NORFID"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("Stampa Etichetta NO-RFID")]
                                      ),
                                      _vm.canResetEPC
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticStyle: { width: "252px" },
                                              attrs: {
                                                color: "primary",
                                                size: "x-large",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.stampaEtichettaPerLavorazioneETaglia(
                                                    "RESET_EPC"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Reset EPC")]
                                          )
                                        : _vm._e(),
                                      _vm.canResetEPC
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticStyle: { width: "252px" },
                                              attrs: {
                                                color: "primary",
                                                size: "x-large",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.stampaEtichettaPerLavorazioneETaglia(
                                                    "PRINT_NEW_SERIAL"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Ristampa nuovo seriale")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "item",
              fn: function ({ item }) {
                return [
                  _c(
                    "tr",
                    {
                      staticClass: "rigaProgresso",
                      attrs: { "data-test": "riga-progresso" },
                    },
                    [
                      item.tipoRiga == 0
                        ? _vm._l(item.values, function (value, index) {
                            return _c(
                              "td",
                              {
                                key: "tot_" + index,
                                staticClass: "rigaProgTot",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      "data-test": "data-element-" + index,
                                    },
                                  },
                                  [_vm._v(_vm._s(value))]
                                ),
                              ]
                            )
                          })
                        : _vm._e(),
                      item.tipoRiga == 1
                        ? _vm._l(item.values, function (value, index) {
                            return _c(
                              "td",
                              {
                                key: "prog_" + value.id + "_" + index,
                                staticClass: "rigaProgSent",
                              },
                              [
                                index > 0
                                  ? _c("span", {
                                      attrs: {
                                        "data-test": "data-element-" + index,
                                      },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          value > 0 ? value : "&nbsp;"
                                        ),
                                      },
                                    })
                                  : _c("div", [
                                      item.ddtResoData
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatDate")(
                                                  item.ddtResoData
                                                )
                                              )
                                            ),
                                          ])
                                        : item.dataElaborazione
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-icon",
                                                              _vm._g({}, on),
                                                              [
                                                                _vm._v(
                                                                  "mdi-information"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Data sincronizzazione del progresso da As-400"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("formatDate")(
                                                      item.dataElaborazione
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          )
                                        : item.dataCreazione
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-icon",
                                                              _vm._g({}, on),
                                                              [
                                                                _vm._v(
                                                                  "mdi-information"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Data creazione progresso"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("formatDate")(
                                                      item.dataCreazione
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]),
                              ]
                            )
                          })
                        : _vm._e(),
                      item.tipoRiga == 2
                        ? [
                            _vm._l(item.values, function (value, index) {
                              return _c(
                                "td",
                                {
                                  key: "edit_" + index,
                                  staticClass: "rigaProgItem",
                                },
                                [
                                  index > 0
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.number",
                                            value: item.values[index],
                                            expression: "item.values[index]",
                                            modifiers: { number: true },
                                          },
                                        ],
                                        staticClass: "rigaProgInput",
                                        attrs: {
                                          "data-test": "rigaProgInput-" + index,
                                          type: "text",
                                        },
                                        domProps: { value: item.values[index] },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              item.values,
                                              index,
                                              _vm._n($event.target.value)
                                            )
                                          },
                                          blur: function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              )
                            }),
                            _c("td", { staticClass: "btnContainer" }, [
                              _c(
                                "div",
                                { staticClass: "btnUpdateProg" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: {
                                        width: "auto !important",
                                        margin: "0",
                                        height: "auto",
                                      },
                                      attrs: {
                                        text: "",
                                        icon: "",
                                        color: "indigo",
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.invioProgresso.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { "data-test": "add-button" },
                                        },
                                        [_vm._v("mdi-plus-circle-outline")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        : _vm._e(),
                      item.tipoRiga == 3
                        ? _vm._l(item.values, function (value, index) {
                            return _c(
                              "td",
                              {
                                key: "left_" + value.id + "_" + index,
                                staticClass: "rigaProgLeft",
                              },
                              [
                                _c("span", {
                                  attrs: {
                                    "data-test": "data-element-" + index,
                                  },
                                  domProps: { innerHTML: _vm._s(value) },
                                }),
                              ]
                            )
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "no-data" },
            [
              _c(
                "v-alert",
                { attrs: { value: true, color: "error", icon: "warning" } },
                [_vm._v(" Sorry, nothing to display here :( ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }